import React, { useState } from "react";
import { Sidebar as ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
//import 'react-pro-sidebar/dist/css/styles.css';

import { Box, IconButton, Typography, useTheme } from "@mui/material";
import {BrowserRouter, Routes, Route, NavLink, Link, } from "react-router-dom";
import { tokens } from "../../theme";
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import  PeopleOutlinedIcon  from "@mui/icons-material/PeopleOutlined";
import  ContactsOutlinedIcon  from "@mui/icons-material/ContactsOutlined";
import  ReceiptOutlinedIcon  from "@mui/icons-material/ReceiptOutlined";
import  PersonOutlinedIcon  from "@mui/icons-material/PersonOutlined";
import  CalendarMonthOutlinedIcon  from "@mui/icons-material/CalendarMonthOutlined";
import  CalendarTodayOutlinedIcon  from "@mui/icons-material/CalendarTodayOutlined";
import  HelpOutlinedIcon  from "@mui/icons-material/HelpOutlined";
import  HelpOutlineOutlinedIcon  from "@mui/icons-material/HelpOutlineOutlined";


import SchoolIcon from '@mui/icons-material/School';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import SummarizeIcon from '@mui/icons-material/Summarize';
import QuizIcon from '@mui/icons-material/Quiz';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SubjectIcon from '@mui/icons-material/Subject';
import BackpackIcon from '@mui/icons-material/Backpack';
import ClassIcon from '@mui/icons-material/Class';
import ViewStreamIcon from '@mui/icons-material/ViewStream';




import  BarChartOutlinedIcon  from "@mui/icons-material/BarChartOutlined";
import  PieChartOutlinedIcon  from "@mui/icons-material/PieChartOutlined";
//PieChartOutlineOutlinedIcon
import  PieChartOutlineOutlinedIcon  from "@mui/icons-material/PieChartOutlineOutlined";
import  TimelineOutlinedIcon  from "@mui/icons-material/TimelineOutlined";
import  MenuOutlinedIcon  from "@mui/icons-material/MenuOutlined";
import  MapOutlinedIcon  from "@mui/icons-material/MapOutlined";

const Item = ({ title, toPath, icon, selected, setSelected }) => {
   const theme = useTheme();
   const colors = tokens(theme.palette.mode);
   return (
    
     <MenuItem
       active={selected === title}
       style={{
         color: colors.grey[100],
       }}
       onClick={() => setSelected(toPath)}
       icon={icon}
     >
       
       <Typography>
       <NavLink to={toPath}  style={{ textDecoration: 'none', backgroundColor:'none' }}>
       {title}
       </NavLink>
       </Typography>
       
     </MenuItem>
     
   );
 };
 
const SidebarZ=({ loginCategory, userId, userName })=>{

   const theme= useTheme();
   const colors= tokens(theme.palette.mode);
   const [isCollapsed, setIsCollapsed] = useState(false);
   const [selected, setSelected] = useState("Dashboard");
    
   //alert("sd=" + loginCategory);
   
   return(

      <Box
         sx={{
            "& .pro-sidebar-inner": {
               background: `${colors.primary[400]} !important`
            },
            "& .pro-icon-wrapper": {
               backgroundColor: "transparent !important"
            },
            "& .pro-inner-item": {
               padding: " 5px 35px 5px 20px !important"
            },
            "& .pro-inner-item:hover": {
               color: " #868dfb !important"
            },
            "& .pro-menu-item.active": {
               color: " #6870fa !important"
            },
         }}
      >
      

      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          
          
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={colors.grey[100]}>
                  
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>
         
          
            

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  //alt="profile-user"
                  alt=""
                  width="100px"
                  height="100px"
                  src={`../../assets/user.png`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  {/***{userName}***/}
                </Typography>
                <Typography variant="h5" 
                color={colors.greenAccent[500]}>
                  {/***VP Fancy Admin***/}
                </Typography>
              </Box>
            </Box>
          )}


          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            

          {
            loginCategory === "Administrator" || loginCategory === "School Administrator" || loginCategory === "School Teacher" ? 
            (
              <>
            <Item
              title="Dashboard"
              toPath="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            </>):''
           }
           

            {
            loginCategory === "Administrator" ? 
            (
              <>

             <Item
              title=" Register Organization"
              toPath="/organization"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Register School"
              toPath="/school"
              icon={<SchoolIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            </>

            ):''
            }

            
        {
          
          loginCategory === "Administrator" ? 
          (
            <>
            <Item
              title=" Register School Admin"
              toPath="/schoolAdmins"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            

            
            <Item
              title="Register Org Director"
              toPath="/OrganizationDirectors"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            {/*** *
            <Item
              title="Register School Owner"
              toPath="/SchoolOwners"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            ***/}
            </>
          ):''
          }
         
         {
          
          loginCategory === "CLASS TEACHER"  ? 
          (
            <>
            <Item
              title=" Register Students"
              toPath="/SchoolStudents"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="View exams reports"
              toPath="/SubClassExamsResults"
              icon={<AssessmentIcon />}
              selected={selected}
              setSelected={setSelected}
            />

          <Item
            title="Announcements Lists"
            toPath="/ListOfAnnouncements"
            icon={<PeopleOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />

            </>
          ):''

        }

         {
          
          loginCategory === "School Administrator" || loginCategory === "HEAD MASTER" ||  loginCategory === "ACADEMIC MASTER"  ? 
          (
            <>
            <Item
              title=" Register Teachers"
              toPath="/schoolTeachers"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          
            
           

             <Item
              title="Create classes"
              toPath="/SchoolClass"
              icon={<ClassIcon />}
              selected={selected}
              setSelected={setSelected}
            />


             <Item
              title="Create Stream"
              toPath="/SchoolSubClass"
              icon={<ViewStreamIcon />}
              selected={selected}
              setSelected={setSelected}
            />


            <Item
              title=" Register Students"
              toPath="/SchoolStudents"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Transfer Students"
              toPath="/TransferStudents"
              icon={<MoveDownIcon />}
              selected={selected}
              setSelected={setSelected}
            />


           <Item
              title="View exams reports"
              toPath="/SubClassExamsResults"
              icon={<AssessmentIcon />}
              selected={selected}
              setSelected={setSelected}
            />
           
           {/*** *
            <Item
              title="Student Stream"
              toPath="/StudentStream"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            ***/}
           <Item
              title="View school exams"
              toPath="/SchoolExams"
              icon={<QuizIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Exam subjects"
              toPath="/ExamSubjects"
              icon={<SubjectIcon />}
              selected={selected}
              setSelected={setSelected}
            />

           {/*** *
            <Item
              title="Parent Reports"
              toPath="/ParentReports"
              icon={<AssessmentIcon />}
              selected={selected}
              setSelected={setSelected}
            />***/}
           
           {/*** *
           <Item
              title="Send Parent Reports"
              toPath="/ParentExamsResults"
              icon={<AssessmentIcon />}
              selected={selected}
              setSelected={setSelected}
            />
           ***/}
           
           <Item
              title="Make Announcement"
              toPath="/AnnouncementsTMT"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

           <Item
              title="Send Parent Credentials"
              toPath="/ParentUsernameAndPasswords"
              icon={<AssessmentIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Students Attendance"
              toPath="/StudentsAttendance"
              icon={<AssessmentIcon />}
              selected={selected}
              setSelected={setSelected}
            />

           </>
          ):''
          }
           

         {
          
          loginCategory === "School Teacher" ? 
          (
            <>
            <Item
              title="View exams reports"
              toPath="/SubClassExamsResults"
              icon={<AssessmentIcon />}
              selected={selected}
              setSelected={setSelected}
            />

           <Item
            title="Student Exam Score"
            toPath="/StudentExamScore"
            icon={<PeopleOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
            </>
           
          ):''
          }


         
      

         {
            loginCategory === "District Administrator" ? 
            (
              <>
            <Item
              title="Exams Data"
              toPath="/DistrictExamsData"
              icon={<SchoolIcon />}
              selected={selected}
              setSelected={setSelected}
            />

              <Item
              title="Announcements"
              toPath="/Announcements"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
           
            </>

            ):''
      }


          {
            loginCategory === "School Owners"  || loginCategory === "ORGANIZATION DIRECTORS" || loginCategory === "Organization Directors" ? 
            (
              <>
            <Item
              title="Exams General Data"
              toPath="/OrganizationExamsData"
              icon={<SchoolIcon />}
              selected={selected}
              setSelected={setSelected}
            />

           <Item
              title="School Exam Reports"
              toPath="/SubClassExamReportsTopLevel"
              icon={<SchoolIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            
            {/*** *
              <Item
              title="Announcements"
              toPath="/Announcements"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
             ***/}

            <Item
              title="Register Head Master"
              toPath="/SchoolTMTHeadMaster"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Register Academic Master "
              toPath="/SchoolTMTAcademicMaster"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

             <Item
              title="Register Class Teachers"
              toPath="/SchoolTMTClassTeachers"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Announcements"
              toPath="/AnnouncementsOrganizationDirector"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
           
            </>

            ):''
           }


       {
          
          loginCategory === "Super Admin" ? 
          (
           <>
            {/***
            <Item
              title="User"
              toPath="/patientRegistration"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          
           <Item
              title="Project Category"
              toPath="/primaryProjectCategoryList"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Projects"
              toPath="/primaryProjects"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Organization Team"
              toPath="/teamOnWebsite"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
             />

            <Item
              title="User Registration"
              toPath="/testform"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Company"
              toPath="/company"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Contacts Information"
              toPath="/contacts"
              icon={<ContactsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Invoices Balances"
              toPath="/invoices"
              icon={<ReceiptOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            ***/}
            </>
          ):''
        }

         {
          
          loginCategory === "Parent" ? 
          (
            <Item
            title="Student Reports"
            toPath="/ExamReportsForParentsAfterLogin"
            icon={<PeopleOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          ):''
          }



         {
          
           loginCategory === "School Teacher" || loginCategory === "School Admin" || loginCategory === "HEAD MASTER" || loginCategory === "ACADEMIC MASTER" || loginCategory === "CLASS TEACHER"? 
          (
            
            <Item
            title="Announcements Lists"
            toPath="/ListOfAnnouncements"
            icon={<PeopleOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />

          ):''
          }

        {
          
          loginCategory === "Parent"? 
          (
            <Item
            title="Announcements Lists"
            toPath="/ListOfParentAnnouncements"
            icon={<PeopleOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          ):''
          }

          
          {/*** *
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Pages
            </Typography>
           
            
            <Item
              title="Profile Form"
              toPath="/form"
              icon={<PersonOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            

            
            <Item
              title="Calendar"
              toPath="/calendar"
              icon={<CalendarTodayOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="FAQ Page"
              toPath="/faq"
              icon={<HelpOutlineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Charts
            </Typography>
            <Item
              title="Bar Chart"
              to="/bar"
              icon={<BarChartOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Pie Chart"
              to="/pie"
              icon={<PieChartOutlineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Line Chart"
              to="/line"
              icon={<TimelineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Geography Chart"
              to="/geography"
              icon={<MapOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            ***/}
          </Box>
        </Menu>
      </ProSidebar>
      
      </Box>
     
   )
}
export default SidebarZ


// /* import React, { useState } from "react";
// import {Sidebar as  ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
// import { Box, IconButton, Typography, useTheme } from "@mui/material";
// import { Link } from "react-router-dom";
// //import "react-pro-sidebar/dist/css/styles.css";
// import { tokens } from "../../theme";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
// import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
// import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
// import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
// import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
// import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
// import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
// import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
// import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
// import MapOutlinedIcon from "@mui/icons-material/MapOutlined";

// const Item = ({ title, to, icon, selected, setSelected }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   return (
//     <MenuItem
//       active={selected === title}
//       style={{
//         color: colors.grey[100],
//       }}
//       onClick={() => setSelected(title)}
//       icon={icon}
//     >
//       <Typography>{title}</Typography>
//       <Link to={to} />
//     </MenuItem>
//   );
// };

// const Sidebar = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [selected, setSelected] = useState("Dashboard");

//   return (
//     <Box
//       sx={{
//         "& .pro-sidebar-inner": {
//           background: `${colors.primary[400]} !important`,
//         },
//         "& .pro-icon-wrapper": {
//           backgroundColor: "transparent !important",
//         },
//         "& .pro-inner-item": {
//           padding: "5px 35px 5px 20px !important",
//         },
//         "& .pro-inner-item:hover": {
//           color: "#868dfb !important",
//         },
//         "& .pro-menu-item.active": {
//           color: "#6870fa !important",
//         },
//       }}
//     >
//       <ProSidebar collapsed={isCollapsed}>
//         <Menu iconShape="square">
//           {/* LOGO AND MENU ICON */}
//           <MenuItem
//             onClick={() => setIsCollapsed(!isCollapsed)}
//             icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
//             style={{
//               margin: "10px 0 20px 0",
//               color: colors.grey[100],
//             }}
//           >
//             {!isCollapsed && (
//               <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 ml="15px"
//               >
//                 <Typography variant="h3" color={colors.grey[100]}>
//                   ADMINIS
//                 </Typography>
//                 <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
//                   <MenuOutlinedIcon />
//                 </IconButton>
//               </Box>
//             )}
//           </MenuItem>

//           {!isCollapsed && (
//             <Box mb="25px">
//               <Box display="flex" justifyContent="center" alignItems="center">
//                 <img
//                   alt="profile-user"
//                   width="100px"
//                   height="100px"
//                   src={`../../assets/user.png`}
//                   style={{ cursor: "pointer", borderRadius: "50%" }}
//                 />
//               </Box>
//               <Box textAlign="center">
//                 <Typography
//                   variant="h2"
//                   color={colors.grey[100]}
//                   fontWeight="bold"
//                   sx={{ m: "10px 0 0 0" }}
//                 >
//                   Ed Roh
//                 </Typography>
//                 <Typography variant="h5" color={colors.greenAccent[500]}>
//                   VP Fancy Admin
//                 </Typography>
//               </Box>
//             </Box>
//           )}

//           <Box paddingLeft={isCollapsed ? undefined : "10%"}>
//             <Item
//               title="Dashboard"
//               to="/"
//               icon={<HomeOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />

//             <Typography
//               variant="h6"
//               color={colors.grey[300]}
//               sx={{ m: "15px 0 5px 20px" }}
//             >
//               Data
//             </Typography>
//             <Item
//               title="Manage Team"
//               to="/team"
//               icon={<PeopleOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//             <Item
//               title="Contacts Information"
//               to="/contacts"
//               icon={<ContactsOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//             <Item
//               title="Invoices Balances"
//               to="/invoices"
//               icon={<ReceiptOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />

//             <Typography
//               variant="h6"
//               color={colors.grey[300]}
//               sx={{ m: "15px 0 5px 20px" }}
//             >
//               Pages
//             </Typography>
//             <Item
//               title="Profile Form"
//               to="/form"
//               icon={<PersonOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//             <Item
//               title="Calendar"
//               to="/calendar"
//               icon={<CalendarTodayOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//             <Item
//               title="FAQ Page"
//               to="/faq"
//               icon={<HelpOutlineOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />

//             <Typography
//               variant="h6"
//               color={colors.grey[300]}
//               sx={{ m: "15px 0 5px 20px" }}
//             >
//               Charts
//             </Typography>
//             <Item
//               title="Bar Chart"
//               to="/bar"
//               icon={<BarChartOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//             <Item
//               title="Pie Chart"
//               to="/pie"
//               icon={<PieChartOutlineOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//             <Item
//               title="Line Chart"
//               to="/line"
//               icon={<TimelineOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//             <Item
//               title="Geography Chart"
//               to="/geography"
//               icon={<MapOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//           </Box>
//         </Menu>
//       </ProSidebar>
//     </Box>
//   );
// };

// export default Sidebar;
// */}